import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { intersperse } from '../../service/Intersperse';
import { ChangedOptions, InlineDisplayGroups } from '../../typings/log';
import {
    ExpandableCell,
    ExpandableProps
} from '../ExpandableCell/ExpandableCell';

import './InlineDisplayCell.css';

export interface InlineDisplayProps extends ExpandableProps {
    diff: InlineDisplayGroups;
}

export class InlineDisplayCell extends ExpandableCell<InlineDisplayProps> {
    protected getContent() {
        return (
            <div
                className={Bem.cls('inline-display-cell')}
                ref={ref => (this.cell = ref)}
            >
                {this.getRowDiv()}
            </div>
        );
    }

    private getRowDiv = (): React.ReactNode => {
        const {
                isExpanded,
                canExpand,
                diff: {
                    [ChangedOptions.added]: addedGroup,
                    [ChangedOptions.removed]: removedGroup,
                    [ChangedOptions.notModified]: notModifiedGroup,
                    [ChangedOptions.off]: offGroup,
                    noInsideComma
                }
            } = this.props,
            spans = [this.getGroup(addedGroup, ChangedOptions.added)]
                .concat(this.getGroup(removedGroup, ChangedOptions.removed))
                .concat(this.getGroup(offGroup, ChangedOptions.off))
                .concat(
                    this.getGroup(notModifiedGroup, ChangedOptions.notModified)
                )
                .filter(obj => obj !== null);

        return (
            <div
                className={classNames(
                    Bem.cls('inline-display-cell', 'row'),
                    !isExpanded && canExpand
                        ? Bem.cls('expandable-cell', 'short-row')
                        : ''
                )}
            >
                {intersperse<React.ReactNode>(
                    noInsideComma ? ' ' : ', ',
                    spans
                )}
            </div>
        );
    };

    /**
     * Отображает группу из диффа (измененные/добавленные/удаленные)
     * @param {Array<string | number>} diffGroup - группа изменений
     * @param {ChangedOptions} type - тип изменений
     * @returns {React.Node}
     */
    private getGroup = (
        diffGroup: Array<string | number>,
        type: string
    ): React.ReactNode => {
        if (!diffGroup || diffGroup.length === 0) {
            return null;
        }

        const spans = diffGroup.map((diffElem, index) => {
            return (
                <span
                    key={type + index}
                    className={classNames(
                        Bem.cls('inline-display-cell', 'span')
                    )}
                >
                    {diffElem}
                </span>
            );
        });

        return (
            <span
                key={`${type}-wrap`}
                className={classNames(
                    Bem.cls('inline-display-cell', 'group'),
                    Bem.cls('inline-display-cell', Bem.beminize(type))
                )}
            >
                {intersperse<JSX.Element>(', ', spans)}
            </span>
        );
    };
}
